import MomentUtils from '@date-io/moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { createBrowserHistory } from 'history';
import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Provider as StoreProvider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import './assets/css/google.css';
import './assets/scss/main.scss';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/StylesProvider';
import './modules/mixins/chartjs';
import './modules/mixins/moment';
import './modules/mixins/prismjs';
import './modules/mixins/validate';
import store from './store';
import { theme } from './modules/theme';
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import Auth from './layouts/Auth';
import { oktaIssuer, oktaClientId } from 'src/utils/contants';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import './signalr/translation';

const persistor = persistStore(store);
const history = createBrowserHistory();

const config = {
  issuer: oktaIssuer,
  redirectUri: `${window.location.origin}/implicit/callback`,
  clientId: oktaClientId,
  pkce: true,
  scopes: ['openid', 'email', 'profile'],
  cookies: {
    secure: false
  }
};

const oktaAuth = new OktaAuth(config);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  history.replace(toRelativeUrl(originalUri, window.location.origin));
};


function App() {
  return (
    <StoreProvider store={store}>
      <PersistGate
        loading={<CircularProgress status="loading" />}
        persistor={persistor}
      >
        <ThemeProvider theme={theme}>
          <StylesProvider direction="ltr">
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Router history={history}>
                <ScrollReset />
                <GoogleAnalytics />
                <Security
                  oktaAuth={oktaAuth}
                  restoreOriginalUri={restoreOriginalUri}
                >
                  <Switch>
                    <Route
                      exact
                      path="/implicit/callback"
                      component={LoginCallback}
                    />
                    <Route path="/" component={Auth} />
                  </Switch>
                </Security>
              </Router>
            </MuiPickersUtilsProvider>
          </StylesProvider>
        </ThemeProvider>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
